import { render } from "./SiteLanguages.vue?vue&type=template&id=0dc3d5b7&scoped=true"
import script from "./SiteLanguages.vue?vue&type=script&lang=js"
export * from "./SiteLanguages.vue?vue&type=script&lang=js"

import "./SiteLanguages.vue?vue&type=style&index=0&id=0dc3d5b7&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc3d5b7"]])

export default __exports__